import React from 'react';
import { motion } from 'framer-motion';

const Hakkimizda = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.4, // Slightly longer delay for smoother effect
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 }, // Start further down for a smoother rise
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { 
                duration: 0.8, // Slower animation for smoother appearance
                ease: [0.42, 0, 0.58, 1], // Custom cubic-bezier for a smoother ease
            },
        },
    };

    return (
        <motion.div 
            className='grid grid-cols-10 w-full pt-10 pb-20'
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className='col-start-2 col-span-8 flex flex-col h-full w-full'>
                <motion.h1 
                    className='text-4xl font-medium text-black mb-10'
                    variants={itemVariants}
                >
                    Hakkımızda
                </motion.h1>
                <motion.div className='space-y-5' variants={containerVariants}>
                    <motion.p variants={itemVariants}>
                    Turkuaz Tekstil, yılların verdiği tecrübe ve uzmanlıkla, tekstil sektöründe kaliteli ve inovatif ürünler sunmanın gururunu taşımaktadır. Kurulduğumuz günden bu yana müşteri memnuniyetini öncelikli hedefimiz olarak belirledik. Geniş ürün yelpazemiz ve yüksek üretim standartlarımız sayesinde, sektördeki yerimizi sağlamlaştırdık.
                    </motion.p>
                    <motion.p variants={itemVariants}>
                    Bu yıl, sağlığı ön planda tutarak yeni bir adım atıyoruz: Medical ürünler alanında da hizmet vermeye başlıyoruz. Amacımız, sağlık sektörüne yönelik kaliteli, güvenilir ve inovatif çözümler sunmaktır. Ürünlerimiz, titizlikle seçilmiş malzemelerle üretilerek en yüksek standartlarda sağlık ve güvenlik koşullarını karşılamaktadır.
                    </motion.p>
                    <motion.p variants={itemVariants}>
                    Turkuaz Tekstil olarak, sağlık çalışanlarının ve hastaların ihtiyaçlarını göz önünde bulundurarak, fonksiyonel ve konforlu medical ürünler geliştirmeyi hedefliyoruz. Sürekli olarak Ar-Ge çalışmalarına yatırım yaparak, sektördeki yenilikleri takip ediyor ve bu yenilikleri ürünlerimize entegre ediyoruz.
                    </motion.p>
                    <motion.p variants={itemVariants}>
                    Müşteri memnuniyetini ve güvenini esas alan bir anlayışla, sağlık alanındaki yolculuğumuza sizleri de davet ediyoruz. Turkuaz Tekstil olarak, gelecekte de kaliteli ürünlerimizle yanınızda olmaktan mutluluk duyacağız.
                    </motion.p>
                    <motion.img 
                        src='/images/hakkimizda.jpg' 
                        className='w-full h-96 object-cover !mt-10'
                        variants={itemVariants}
                    />
                </motion.div>
            </div>
        </motion.div>
    );
};

export default Hakkimizda;
